import { useCallback, useEffect, useState } from "react";
import { useEventTools } from "services/app/use-cases/events/event-tools";
import { AppEventEnum } from "model/enums/enum-event-app";
import { useLocation } from "react-router-dom";
import { DialogTransferencia } from "views/components/dialog/dialog-transferência/dialog-transferencia";

class TransferenciaDialogProps {
    constructor(
        public aberto: boolean = false,
        public id?: string,
    ) { }
}

const transferenciaRoute = `/gerenciar/transferencia/`;
const inicialRoute = `/inicial`

export const TransferenciaDialog = () => {
    const { addHandler, removeHandler } = useEventTools();
    const [modalState, setModalState] = useState<TransferenciaDialogProps>(
        new TransferenciaDialogProps()
    );

    const location = useLocation();

    useEffect(() => {
        if (location.pathname.includes(transferenciaRoute) && location.pathname.includes(inicialRoute)) {
            const posrota = location.pathname.split(transferenciaRoute)[1];
            const id = posrota
            if (posrota.length > 0 && (posrota.length === 36 || posrota.includes('adicionar'))) {
                setModalState(prev => ({
                    aberto: true,
                    id: id && id.length === 36 ? id : prev.id
                }));
                return;
            }
        }
    }, [location.pathname]);

    const modalAlterado = useCallback(({ aberto, id }: TransferenciaDialogProps) => {
        setModalState({
            aberto,
            id,
        });
    }, [])

    useEffect(() => {
        addHandler(AppEventEnum.DialogTransferencia, modalAlterado);
        return () => {
            removeHandler(AppEventEnum.DialogTransferencia, modalAlterado);
        };
    }, [addHandler, modalAlterado, removeHandler]);

    return (
        <>
            {modalState.aberto && (
                <DialogTransferencia aberto={modalState.aberto} id={modalState.id} />
            )}
        </>
    )
}